// ==========================================================================
// Brand Service - Fetch brand configurations from Laravel API
// ==========================================================================

import api from '@/lib/axios';
import type { BrandConfig } from '@/types/brand';

/**
 * Fetch brand configuration by FSP ID
 */
export async function fetchBrandConfig(fspId: string): Promise<BrandConfig> {
  const response = await api.get<BrandConfig>(`/brands/${fspId}`);
  return response.data;
}

/**
 * Validate FSP ID exists
 */
export async function validateFspId(fspId: string): Promise<boolean> {
  try {
    await api.get<{ valid: boolean }>(`/brands/${fspId}/validate`);
    return true;
  } catch {
    return false;
  }
}
